import qs from 'qs'

export function getQuery() {
  const query = location.search.substring(1)
  return query ? qs.parse(query) : {}
}


// WEBPACK FOOTER //
// ./src/utils/url.js